module.exports = __webpack_public_path__ + "img/1491254405-recenttimesearchreloadtime_82966.15b50d1f.svg";